export const downloadFile = (data: any, fileName: string, fileType) => {
	const downloadUrl = window.URL.createObjectURL(new Blob([data], { type: fileType }));
	const link = document.createElement("a");
	link.href = downloadUrl;
	link.download = fileName;
	document.body.appendChild(link);
	link.click();
};

function getFileNameFromHeaders(headers: Record<string, string>): string | undefined {
	if (!headers) return;

	const contentDisposition = headers["content-disposition"];
	if (!contentDisposition) return;

	const match = contentDisposition.match(/filename="?(.+)?"/);
	if (match && match.length > 1) {
		return match[1];
	}
}

export const openGenericFile = (data: any, headers: Record<string, string>) => {
	const blob = new Blob([data]);
	const downloadUrl = window.URL.createObjectURL(blob);

	const link = document.createElement("a");
	link.href = downloadUrl;
	link.target = "_blank";
	link.download = getFileNameFromHeaders(headers) || `ars-file`;

	document.body.appendChild(link);
	link.click();

	window.URL.revokeObjectURL(downloadUrl);
};
